import React from 'react';
import styled from 'styled-components';

const HelpLinkStyled = styled.a`
  display: block;
  text-align: right;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  text-decoration: none;
  margin-top: 24px;

  @media (max-width: 900px) {
    font-size: 15px;
  }

  @media (max-width: 760px) {
    color: #8a9ab0;
  }

  &:hover {
    color: #fa4616;
  }
`;

export default () => (
  <HelpLinkStyled
    target="_blank"
    rel="noopener noreferrer"
    href="https://promoters.pitpay.com"
  >
    Having Trouble?
  </HelpLinkStyled>
);
